import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js'
import { Line } from 'react-chartjs-2';
import "./Graph.css";
import {setShortFormart, getMonth} from "../../../helpers/Date";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);
function  LineChart (props){
  const numberFormat = new Intl.NumberFormat();
  function obtenerLabels (arr,arrC = []){

    let labels = [];
    switch (props.grupoTiempo) {
      case 'dia':
        arr.forEach((element,index) => {
          let auxLabel = [setShortFormart(element.fecha)];
         
          labels.push(auxLabel);
        });
        break;
      case 'semana':
        arr.forEach(element => {
          let label = 'Semana - ' + element[props.grupoTiempo];
          labels.push(label);
        });
        break;
      case 'mes':
          arr.forEach(element => {
            labels.push(getMonth(element[props.grupoTiempo]));
          });
          break;
      case 'anio':
        arr.forEach(element => {
          labels.push(element[props.grupoTiempo]);
        });
        break;
      default:
        break;
    }
    
    return labels;
  }

  function obtenerDatasets (arr){
    let unidades = [];
    let ventas = [];
    let pagos = [];
    let labels = []
    labels = obtenerLabels(arr);
    arr.forEach(element => {
      unidades.push(parseInt(element.unidades_periodo));
      ventas.push(parseInt(element.periodo_venta));
      pagos.push(parseInt(element.periodo_pago_proveedor));
    });
    return {
      unidades,
      ventas,
      pagos,
      labels
    };
  }
  let infoPrincipal = obtenerDatasets(props.data);
  let infoComparar = [];
  let labels = obtenerLabels(props.data,props.dataComparar);

  if(props.comparar && props.dataComparar.length > 0){
    infoComparar = obtenerDatasets(props.dataComparar);
  }
  const data = {
    labels: labels,

    datasets: [
      {
        label: 'Ventas',
        data: infoPrincipal.ventas,
        borderColor: '#0698CE',
        backgroundColor: '#0698CE',
        fill:false,
        borderWidth:1,
        radius:2,
        
      },
      {
        label: 'Comparar1',
        data: infoComparar.ventas,
        borderColor: 'orange',
        backgroundColor: 'orange',
        fill:false,
        borderWidth:1,
        radius:2,
        
      }
    ],
    
  };
  const options = {
    layout: {
      padding: {
        y:20,
        x:10
      }
    },
    scales: {
      
      y: {
        beginAtZero: false,
        ticks:{
          callback: function(label) {
            
            return '$ '+numberFormat.format(label);
          },
          format:{
            
          }
        }
      },
      x: {
        ticks:{
          callback: function(val, indexn,ticks) {
            return this.getLabelForValue(val);
          },
          color:'rgb(0,0,0,0.8)',
        }
      },
    },
    interaction: {
      intersect: false,
      mode: 'point',
    },
    plugins: {
      tooltip: {
        titleAlign:'center',
        displayColors:false,
        boderWidth:50,
        callbacks:{
          title:(item)=>{
            console.log('title',item);
            switch (item[0].dataset.label) {
              case 'Ventas':
                return infoPrincipal.labels[item[0].dataIndex];
              case 'Comparar1':
                return infoComparar.labels[item[0].dataIndex];
              default:
                break;
            }
          },
          beforeLabel:(item)=>{
            switch (item.dataset.label) {
              case 'Ventas':
                return 'Unidades:         '+numberFormat.format(infoPrincipal.unidades[item.dataIndex]);
              case 'Comparar1':
                return 'Unidades:         '+numberFormat.format(infoComparar.unidades[item.dataIndex]);
              default:
                break;
            }
          },
          label:(item)=>{
            switch (item.dataset.label) {
              case 'Ventas':
                return 'Ventas:      $ '+numberFormat.format(infoPrincipal.ventas[item.dataIndex]);
              case 'Comparar1':
                return 'Ventas:      $ '+numberFormat.format(infoComparar.ventas[item.dataIndex]);
              default:
                break;
            }
          },
          afterLabel:(item)=>{
            switch (item.dataset.label) {
              case 'Ventas':
                return 'Pago:        $ '+numberFormat.format(infoPrincipal.pagos[item.dataIndex]);
              case 'Comparar1':
                return 'Pago:        $ '+numberFormat.format(infoComparar.pagos[item.dataIndex]);
              default:
                break;
            }
          }
        }
  
      },
      legend:{
        display:false
      },
      title:{
        display:true,
        text:'Periodo',
        position:'bottom',
        font:{weight: 'bold'}

      },
      subtitle:{
        display:true,
        text:'Ventas',
        position:'left',
        font:{weight: 'bold'}
      }
  }
  };
  
  return (
    <Line id="grafico_ventas" redraw={false} data={data} className={'line-graph'} options={options} height={55}/>
  )
};

export default LineChart;